module.exports = __webpack_public_path__ + "static/media/clocards-favs.6a986503.png";